import { type SvgIconProps } from '@mui/material';
import React from 'react';

function DocumentPencilIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      viewBox="0 -1 41 41"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_6068_70650"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="41"
      >
        <path d="M36 0H0V36H36V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_6068_70650)">
        <path
          d="M24.9963 5.98955L19.134 0.215655C18.9937 0.0774607 18.8047 0 18.6077 0H1.81066C1.61175 0 1.42098 0.0790177 1.28033 0.21967L0.21967 1.28033C0.0790178 1.42098 0 1.61175 0 1.81066V34.1894C0 34.3882 0.0790178 34.579 0.21967 34.7197L1.28033 35.7803C1.42098 35.921 1.61175 36 1.81066 36H23.4094C23.6083 36 23.7991 35.921 23.9397 35.7803L25.0004 34.7197C25.1411 34.579 25.22 34.3882 25.22 34.1894V6.5239C25.22 6.32301 25.1395 6.13052 24.9963 5.98955Z"
          fill="#FF5200"
        />
        <path
          d="M16.17 9.34942L14.2972 7.47661C14.1566 7.33595 13.9658 7.25694 13.7669 7.25694H12.1752M12.1752 7.25694H10.5837C10.3848 7.25694 10.194 7.33595 10.0533 7.47661L9.16106 8.36887C9.02043 8.5095 8.94138 8.7003 8.94138 8.8992V10.5606C8.94138 10.7595 9.02043 10.9503 9.16106 11.0909L10.0533 11.9832C10.194 12.1238 10.3848 12.2029 10.5837 12.2029H13.7669C13.9658 12.2029 14.1566 12.2818 14.2972 12.4225L15.1895 13.3147C15.3301 13.4554 15.4092 13.6462 15.4092 13.8451V15.1261C15.4092 15.325 15.3301 15.5158 15.1895 15.6564L14.2972 16.5487C14.1566 16.6893 13.9658 16.7683 13.7669 16.7683H12.1752M12.1752 7.25694V4.59375M7.99023 14.4856L10.0533 16.5487C10.194 16.6893 10.3848 16.7683 10.5837 16.7683H12.1752M12.1752 16.7683V19.2412"
          stroke="black"
          strokeWidth="2"
        />
        <path d="M3.04395 24.375H15.2185" stroke="black" strokeWidth="2" />
        <path d="M3.04395 28.5615H13.6967" stroke="black" strokeWidth="2" />
        <path
          d="M18.9805 32.9093H21.6292C21.8281 32.9093 22.0188 32.8303 22.1595 32.6896L34.5916 20.2575C34.8844 19.9647 34.8844 19.4898 34.5916 19.1969L32.693 17.2983C32.4001 17.0054 31.9252 17.0054 31.6323 17.2983L19.2002 29.7304C19.0596 29.871 18.9805 30.0618 18.9805 30.2607V32.9093ZM18.9805 32.9093H3.04395"
          stroke="black"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default DocumentPencilIcon;
